var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.notValid,
            expression: "!notValid"
          }
        ],
        staticClass: "container azSize has-text-centered"
      },
      [
        _c("div", { staticClass: "is-loading top80" }, [_vm._v(" ")]),
        _vm._v(" "),
        _c("div", { staticClass: "is-size-3 has-text-white isPoppins top40" }, [
          _c("b", [_vm._v("Just a sec, please...")])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.notValid,
            expression: "notValid"
          }
        ],
        staticClass: "container"
      },
      [
        _c("div", { staticClass: "is-size-3 has-text-white isPoppins top80" }, [
          _c("b", [_vm._v("Invalid Request. ")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "is-size-5 has-text-white isPoppins top20" }, [
          _vm._v(
            "If you got here by clicking a verification link, please contact support."
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3db8bc17", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db8bc17","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Activate.vue
// module id = null
// module chunks = 